export type FundInvestiment = {
    category: WatchlistsItemCategories
    cusip: string;
    label: string;
    link: string;
    ticker: string;
    settings?: object;
    details?: object;
    poid?: string;
    wid?: string;
}

export class WatchlistsItem {
    wid?: string;
    poid?: string;
    ticker: string;
    category: WatchlistsItemCategories;
    label: string;
    details?: object;
    created?: number;
    updated?: number;
    settings?: object;
    link: string;
    cusip:string;
    pendingDelete?:boolean;
}
export type User = {
    poid: string;
}

export enum WatchlistsItemCategories {
    DEFAULT = 'DEFAULT',
    VanguardMutualFund = 'Mutual Fund',
    VanguardETF = 'ETF',
    Securities = 'Stock',
    Other = 'Other',
}

export type Watchlist = {
    wid: string;
    poid: string;
    title: string;
    settings: object;
    created: number;
    updated: number;
    precreated?: boolean;
    createdBy: string;
    isDeleted: boolean;
    watchlistItems: WatchlistsItem[];
}

export type ResponseGetAllWatchlist = {
    watchlists: Watchlist[];
    watchlistsWithFund: string[];
}